import { render, staticRenderFns } from "./PrimarySignUpDialog.vue?vue&type=template&id=578e8556&scoped=true"
import script from "./PrimarySignUpDialog.vue?vue&type=script&lang=js"
export * from "./PrimarySignUpDialog.vue?vue&type=script&lang=js"
import style0 from "./PrimarySignUpDialog.vue?vue&type=style&index=0&id=578e8556&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e8556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578e8556')) {
      api.createRecord('578e8556', component.options)
    } else {
      api.reload('578e8556', component.options)
    }
    module.hot.accept("./PrimarySignUpDialog.vue?vue&type=template&id=578e8556&scoped=true", function () {
      api.rerender('578e8556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/PrimarySignUpDialog.vue"
export default component.exports